import { render, staticRenderFns } from "./Encerramentos.vue?vue&type=template&id=3d0c00bb&scoped=true&"
import script from "./Encerramentos.vue?vue&type=script&lang=js&"
export * from "./Encerramentos.vue?vue&type=script&lang=js&"
import style0 from "./Encerramentos.vue?vue&type=style&index=0&id=3d0c00bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c00bb",
  null
  
)

export default component.exports